module.exports = __webpack_public_path__ + "img/individual_weddingrings@2x.bfc8061.webp";